import React from 'react';

const App = () => (
    <div className="container">
        Welcome back to the home page!
    </div>
);
export default App;